// path-to-your-redux-actions.js
export const UPDATE_BOOKING_DETAILS = 'UPDATE_BOOKING_DETAILS';

export const customerBookingDetails = (bookingDetails) => ({
  type: UPDATE_BOOKING_DETAILS,
  payload: bookingDetails,
});
